import * as React from "react";
import { SwalButtons } from "source/app/services/Shared/RenderSwal/SwalBody/SwalButtons";
import { SaveNodeChangesAsync } from "../SaveNodeChangesAsync";

export function SaveIcon() {
    return (
        <SwalButtons.Save
            onClick={async () => await SaveNodeChangesAsync()}
        />
    );
}
